import { AppUser } from 'models/AppUser';
import React, { useState } from 'react';

import nameof from 'ts-nameof.macro';
import './Login.scss';
import useLogin from './LoginService';
import GetOtp from './GetOtp';
import ChangePassword from './ChangePassword';
import ForgotPassword from './ForgotPassword';

function Login() {
  const [appUser, setAppUser] = useState<AppUser>({
    ...new AppUser(),
    username: '',
    password: '',
  });
  const [errorMessageUsername, setErrorMessageUsername] = useState<string>(
    null,
  );
  const [errorMessagePass, setErrorMessagePass] = useState<string>(null);
  const [errorMessageOtp, setErrorMessageOtp] = useState<string>(null);
  const [
    loginVisible,
    forgotPasswordVisible,
    getOtpVisible,
    changePassVisible,
    ,
    checkPass,
    confirmPass,
    showForgotPassword,
    handleChangeEmail,
    handleChangeOtp,
    handleSendOtp,
    handleSendMail,
    handleChangeNewPass,
    handleChangeConfirmPassword,
    handleChangePass,
    showLogin,
    handleLogin,
    handleChangeField,
    handleEnter,
    logo,
    otp,
  ] = useLogin(
    appUser,
    setAppUser,
    setErrorMessageUsername,
    setErrorMessagePass,
    setErrorMessageOtp,
  );

  // const handleLoginWithSSO = useCallback(() => {
  //   loginConfigurationRepository
  //     .getAuthorizationEndpoint(localStorage.getItem('loginConfigurationId'))
  //     .then(res => {
  //       return window.open(res.toString(), '_self');
  //     });
  // }, []);

  return (
    <>
      <div className="login__wrapper d-flex">
        <div className="login__left-side">
          <div className="login__info"></div>
        </div>
        <div className="login__right-side d-flex flex-column">
          <div className="login-left__header">
            <img
              className="header__logo"
              src={logo.icon}
              alt="IMG"
              height={150}
              width={150}
            />
          </div>
          <div className="login-left__body">
            <div className="login__form d-flex flex-column">
              <div className="form__title">
                <span>Login</span>
              </div>
              {loginVisible === true && (
                <div>
                  <div className="form__field">
                    <div className="field__title d-flex justify-content-between">
                      <div className="title__left-side">
                        Tên đăng nhập/Username
                      </div>
                      <div className="title__right-side">
                        {errorMessageUsername && (
                          <span>{errorMessageUsername}</span>
                        )}
                      </div>
                    </div>
                    <input
                      className="field__input"
                      type="text"
                      value={appUser.username}
                      placeholder="Nhập tên đăng nhập"
                      onChange={handleChangeField(nameof(appUser.username))}
                      onKeyDown={handleEnter}
                      autoComplete={'off'}
                    />
                  </div>
                  <div className="form__field">
                    <div className="field__title d-flex justify-content-between">
                      <div className="title__left-side"> Mật khẩu/Password</div>
                      <div className="title__right-side">
                        {errorMessagePass && <span>{errorMessagePass}</span>}
                      </div>
                    </div>
                    <input
                      className="field__input"
                      type="password"
                      value={appUser.password}
                      placeholder="Nhập mật khẩu"
                      onChange={handleChangeField(nameof(appUser.password))}
                      onKeyDown={handleEnter}
                    />
                  </div>
                  <div className="form__action d-flex justify-content-between">
                    <div className="forgot-password pointer">
                      <span
                        className="mt-2 pointer"
                        onClick={() => showForgotPassword()}
                      >
                        Quên mật khẩu/Forgot password
                      </span>
                    </div>
                  </div>
                  <div className="form__action-button">
                    <div
                      className="form__button"
                      onClick={
                        errorMessagePass !== null ||
                        errorMessageUsername !== null
                          ? undefined
                          : handleLogin
                      }
                    >
                      <span>Đăng nhập/Login</span>
                    </div>
                  </div>
                </div>
              )}
              {forgotPasswordVisible === true && (
                <ForgotPassword
                  onChangeEmail={handleChangeEmail}
                  onSendMail={handleSendMail}
                  showLogin={showLogin}
                />
              )}

              {getOtpVisible === true && (
                <GetOtp
                  onChangeOtp={handleChangeOtp}
                  showLogin={showLogin}
                  onSendOtp={handleSendOtp}
                  otp={otp}
                  errorMessageOtp={errorMessageOtp}
                />
              )}
              {changePassVisible === true && (
                <ChangePassword
                  onChangeNewPass={handleChangeNewPass}
                  onChangeConfirmPassword={handleChangeConfirmPassword}
                  onChangePass={handleChangePass}
                  checkPass={checkPass}
                  confirmPass={confirmPass}
                  showLogin={showLogin}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
